import Paths from "routes/Paths";

import type { IconName, NewTreeForm, Status, TreeFilter } from "./models";

const publicUrl = process.env.PUBLIC_URL;

export const defaultCoverPreview = `${publicUrl}/assets/home/middle-earth.svg`;

// Items without a path have no page yet; the sidebar renders them pointing home.
// `key` addresses the label under `navigation` in the homePage namespace.
export const navItems: Array<{ icon: IconName; key: string; path?: string }> = [
	{ icon: "tree", key: "myTrees", path: Paths.root },
	{ icon: "people", key: "sharedWithMe", path: Paths.sharedWithMe },
	{ icon: "compass", key: "explore", path: Paths.explore },
	{ icon: "settings", key: "settings", path: Paths.settings }
];

// The filter values themselves; their labels live under `toolbar.filters` in the namespace.
export const filters: TreeFilter[] = ["All", "Draft", "Private", "Public"];

// `type` is the API entity type and doubles as the label key under `editor.entityGroups`.
export const entityGroups: Array<{ icon: IconName; type: string }> = [
	{ icon: "people", type: "Person" },
	{ icon: "compass", type: "Place" },
	{ icon: "tree", type: "Object" },
	{ icon: "creature", type: "Creature" },
	{ icon: "organization", type: "Organization" },
	{ icon: "event", type: "Event" },
	{ icon: "species", type: "Species" },
	{ icon: "sparkle", type: "Concept" },
	{ icon: "custom", type: "Custom" }
];

export const avatarTones = ["avatarGold", "avatarSage", "avatarInk"];

// `value` is the stored visibility; its label and caption live under `createDialog.visibilityOptions`.
export const visibilityOptions: Array<{ icon: IconName; value: Status }> = [
	{ icon: "pencil", value: "Draft" },
	{ icon: "lock", value: "Private" },
	{ icon: "globe", value: "Public" }
];

export const createTreeInitialForm: NewTreeForm = {
	commentsWhenPublic: false,
	description: "",
	title: "",
	visibility: "Private"
};
